/**
 * FeatureGateHost (NER-3161) — punto de montaje único del FeatureGateModal.
 *
 * Escucha el evento global `FEATURE_GATE_EVENT` que dispara:
 *   - el interceptor de `services/api.js` ante un 403 FEATURE_GATE_REJECTED, y
 *   - `openFeatureGate(...)` en pre-checks del FE (useFeatureGate).
 *
 * Se monta una sola vez dentro del árbol de providers + Router (ver App.js) para
 * que el modal tenga acceso a i18n, SubscriptionContext y react-router.
 */

import React, { useEffect, useState } from 'react';
import { FEATURE_GATE_EVENT } from '../config/featureGates';
import FeatureGateModal from './FeatureGateModal';

function FeatureGateHost() {
  const [gate, setGate] = useState(null);

  useEffect(() => {
    const onGate = (e) => {
      if (e?.detail?.feature) setGate(e.detail);
    };
    window.addEventListener(FEATURE_GATE_EVENT, onGate);
    return () => window.removeEventListener(FEATURE_GATE_EVENT, onGate);
  }, []);

  if (!gate) return null;

  return <FeatureGateModal gate={gate} onClose={() => setGate(null)} />;
}

export default FeatureGateHost;
